import { createFileRoute, redirect } from '@tanstack/react-router'
import { PostingIntentsScreen } from '@/features/accounting-posting-intents/posting-intents-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/posting-intents')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'payroll_run_post.create')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: PostingIntentsScreen,
})
